import axios from 'axios'

const baseURL = 'https://app.useral.com/api/v1/'
export default axios.create({
  baseURL
  // You can add your headers here
})
